module.exports = __webpack_public_path__ + "img/upload-red.46c5db14.svg";